// extracted by mini-css-extract-plugin
export default {"Main":"Loading_Main__EDAQq"};